<script lang="ts">
    import Carousel, {onDestroyed} from "../Carousel.svelte";
    import ProductCase from "./ProductCase.svelte";
    import {onMount} from "svelte";
    import { Link } from "svelte-navigator";
    import type { TradeBrand } from "../model";

    /**
     * Brand products
     * Can be empty to hide
     */
    export let brandProducts : TradeBrand = null;

    /**
     * products who showing in carousel
     */
    export let products = []

    /**
     * number of product showing on screen size
     */
    export let perPage = 5

    /**
     * by default product click replace history
     */
    export let replaceHistory = true;

    let mounted = false;
    let clickable = false; // enable/disable link on product case
    let m = {x: 0, y: 0}; // mouse position to detect if mouse is swiping
    let showArrowLeft = false; // show/hide the left arrow control
    let showArrowRight = false; // show/hide the right arrow control
    let countSlide = brandProducts ? products.length + 1 : products.length // define total count of product
    let show = true; // show/hide (mount/unmount) the carousel
    let carousel; // carousel component binding

    let heightBrand = -1; //height brand case, buy default heigher is set to 100% : -1 => 100%

    /**
     * refresh carousel if number of masonry column change
     */
    $: if (perPage) {
        if (mounted) {
            refreshCarousel()
        }
    }

    onMount(() => {
        mounted = true;
        refreshCarousel()
    })

    /**
     * unmount and mount the carousel to refresh
     */
    function refreshCarousel() {
        show = false
        carousel.onDestroyed().then(() => {
            show = true
        })
    }

    /**
     * define number of column in term on slide quantity
     */
    function definePerPage(): number {
        if (countSlide < perPage) {
            showArrowLeft = false
            showArrowRight = false
            return countSlide
        } else {
            showArrowLeft = false
            showArrowRight = true
            return perPage
        }
    }

    /**
     * enable/disable dragable carousel in terms of the total slide and perPage count
     */
    function defineDraggable(): boolean {
        return countSlide >= perPage;
    }

    /**
     * save mouse position on click down
     * @param event
     */
    function onMouseDown(event) {
        m.x = event.clientX;
        m.y = event.clientY;
    }

    /**
     * compare mouse position on click up to define if mouse is swiping
     * @param event
     */
    function onMouseUp(event) {
        let x = event.clientX;
        let y = event.clientY;
        clickable = x == m.x || y == m.y;
    }

    /**
     * define the show/hide of the arrows control
     * @param carouselInfo
     */
    function showArrow(carouselInfo) {
        let firstSlide = carouselInfo.currentSlide
        let lastSlide = carouselInfo.currentSlide + perPage
        let totalSlide = carouselInfo.slideCount

        showArrowLeft = firstSlide > 0
        showArrowRight = lastSlide < totalSlide
    }

</script>

<style lang="scss">
  @import "../styles/variables.scss";

  #product-carousel {
    width: 100%;
    height: 100%;
    .product-case {
      margin: 0 5px;
      display: flex;
      width: 100%;
      height: 100%;
    }

    .brand {
    
      width: 100%;
      cursor: pointer;
      display: flex;
      flex-direction: column;
      text-align: center;
      float: left;
      overflow: hidden;
      gap: 2px;
      border-radius: 12px;
      border: solid 1px black;
      background-color: white;
      margin: 5px;

      .brand-name {
        width: 100%;
        background-color: $dark-black;
        color : white;
      }
      .brand-image {
        max-height: 90%;
        width: 100%;
        object-fit: contain;
        object-position: center;
        display: flex;
        margin: auto;
      }
    }

    // button of array slide control in carousel
    .arrow-control {
      transition: 1s ease;
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      position: absolute;
      top: 0;

      &.left {
        left: -20%;
      }

      &.right {
        right: -20%;
      }

      &.hide {
        display: none;
      }

      .containerNavButton {
        background-size: 20%;
        background-repeat: no-repeat;
        background-position: center;
        border-radius: 100%;
        background-color: white;
        color: $dark-black;
        border: unset;
        width: 60px;
        height: 60px;
        cursor: pointer;
        transition: 0.3s ease;
        font-size: 1.5rem;

        &:hover {
          background-color: $dark-black;
          color: white;
          transition: 0.3s ease;
        }
      }

      &:hover {
        transform: scale(1.2);
        transition: 0.3s ease;
      }

      &:active {
        transition: 0.1s ease;
        transform: scale(1);
      }
    }
  }

  .isAlone {
    max-width: 25em;
    @media (max-width: $mobile-breakpoint) {
        max-width: 100%;
    }
  }
</style>

{#if show && products && products.length > 0}
    <div id="product-carousel">
        <Carousel perPage="{definePerPage()}" draggable="{defineDraggable()}" bind:this={carousel}
                  multipleDrag="{true}" dots="{false}" loop="{false}" on:on-change={(e) => {showArrow(e.detail) }}>
            {#if brandProducts}
                <Link to="../products?brand={brandProducts.name}">
                  <div class="brand" style="height: {heightBrand == -1 ? "100%" : `${heightBrand}px`};">
                      <div class="brand-name">
                        <h1>{brandProducts.name}</h1>
                      </div>
                      <img class="brand-image" src={brandProducts.logo_url} alt="logo de la marque">
                  </div>
                </Link>
            {/if}
            
            {#each products as product, index (product.uid)}
              <!-- bind height to change brand div heigher-->
              {#if brandProducts}
                <div class="product-case" bind:clientHeight={heightBrand} on:mousedown={onMouseDown} on:mouseup={onMouseUp}>
                    <ProductCase product={product}
                                index={0}
                                crossSell="{true}"
                                replaceHistoryOnClick={false}
                                clickable="{clickable}">
                    </ProductCase>
                </div>
              {:else}
                <div class="product-case" class:isAlone={products.length == 1} on:mousedown={onMouseDown} on:mouseup={onMouseUp}>
                    <ProductCase product={product}
                                index={0}
                                crossSell="{true}"
                                replaceHistoryOnClick={replaceHistory}
                                clickable="{clickable}">
                    </ProductCase>
                </div>
              {/if}
            {/each}

            <div class="arrow-control left" class:hide={!showArrowLeft} slot="left-control">
                <button class="containerNavButton"><i class="fas fa-chevron-left"></i></button>
            </div>

            <div class="arrow-control right" class:hide={!showArrowRight} slot="right-control">
                <button class="containerNavButton"><i class="fas fa-chevron-right"></i></button>
            </div>

        </Carousel>
    </div>
{/if}
